<template>
  <v-app-bar>
    <v-card
      color="primary"
      img="https://cdn.vuetifyjs.com/images/home/vuetify_layout1.svg"
      height="100px"
    ></v-card>
    <router-link class="mt-3" to="/" tag="a">
      <img class="responsive" to="/" src="@/assets/log.png" alt="Logo" />
    </router-link>
    <v-spacer class="hidden-md-and-up"></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn
        v-for="(item, index) in items"
        :key="index"
        :to="item.path"
        color="#002f6c"
        text
      >
        <span class="text-uppercase body-2 font-weight-bold">{{
          item.title
        }}</span>
      </v-btn>
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <!-- <v-btn color="#002f6c" text href="https://micuenta.telemontv.com/Login">
        <v-icon color="#002f6c" left>credit_card</v-icon>
        PAGAR AQUI
      </v-btn> -->
         <v-btn color="#002f6c" text to="support">
        <v-icon color="#002f6c" left>help</v-icon>
        Soporte y ayuda
      </v-btn>
      <v-btn color="#002f6c" to="/login" text>
        <v-icon color="#002f6c" left>account_circle</v-icon>
        {{ user == null ? "Mi cuenta" : "Mi Cuenta" }}
      </v-btn>
    </v-toolbar-items>
    <v-menu class="hidden-md-and-up" left bottom>
      <template v-slot:activator="{ on }">
        <v-btn  class="hidden-md-and-up" v-on="on" icon>
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          :to="item.path"
          color="#002f6c"
        >
          <v-list-item-content>
            <v-list-item-title class="text-uppercase body-2 font-weight-bold">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <template v-slot:activator="{ on }">
      <v-btn class="hidden-md-and-up" v-on="on" icon>
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </template>
  </v-app-bar>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Toolbar",
  data: () => ({
    items: [
      {
        title: "inicio",
        path: "/",
      },
      {
        title: "paquetes tv",
        path: "/packages",
      },
      {
        title: "nosotros",
        path: "/about",
      },
      
    ],
  }),

  computed: {
    ...mapState({ user: "user" }),
  },
};
</script>
<style scoped>
.responsive {
  width: 100%;
  max-width: 100px;
  height: auto;
}
</style>
